export interface Movie {
  id: number;
  title: string;
  originalTitle: string;
  category: string;
  year: number;
  rating: number;
  duration: string;
  poster: string;
  description: string;
  tags: string[];
  director: string;
  actors: string[];
  region: string;
  isHot: boolean;
  isNew: boolean;
  views: number;
  releaseDate: string;
}

export const movies: Movie[] = [
  {
    id: 1,
    title: '烈火战将',
    originalTitle: 'Blazing Warriors',
    category: 'dongzuo',
    year: 2025,
    rating: 8.7,
    duration: '128分钟',
    poster: 'https://readdy.ai/api/search-image?query=Epic%20action%20movie%20poster%20with%20a%20soldier%20in%20combat%20gear%20standing%20amid%20explosions%20and%20fire%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20dark%20background%20with%20warm%20orange%20flames%2C%20movie%20poster%20design%20with%20Chinese%20text%20style&width=600&height=900&seq=movie-poster-001&orientation=portrait',
    description: '一位退役特种兵为保护家人，独自对抗整个犯罪集团。在枪林弹雨中，他用血肉之躯筑起最后一道防线。影片以惊人的动作场面和深刻的情感刻画，呈现了一场关于勇气与牺牲的壮烈史诗。',
    tags: ['动作', '枪战', '热血', '犯罪'],
    director: '陈凯锋',
    actors: ['吴京', '张译', '黄渤', '王宝强'],
    region: '中国大陆',
    isHot: true,
    isNew: true,
    views: 1256000,
    releaseDate: '2025-07-15',
  },
  {
    id: 2,
    title: '星际迷航：新纪元',
    originalTitle: 'Star Trek: New Era',
    category: 'kehuan',
    year: 2025,
    rating: 9.1,
    duration: '145分钟',
    poster: 'https://readdy.ai/api/search-image?query=Science%20fiction%20movie%20poster%20with%20a%20spaceship%20flying%20through%20a%20colorful%20nebula%2C%20futuristic%20design%2C%20deep%20space%20background%2C%20stars%20and%20galaxies%2C%20cinematic%20movie%20poster%20style%20with%20epic%20scale&width=600&height=900&seq=movie-poster-002&orientation=portrait',
    description: '公元2157年，人类首次发现宜居系外行星。一支探险队踏上征程，却在未知星球上遭遇了超乎想象的智慧生命，人类的命运由此改变。',
    tags: ['科幻', '太空', '冒险', '视效大片'],
    director: '詹姆斯·卡梅隆',
    actors: ['刘德华', '周迅', '陈坤'],
    region: '中美合拍',
    isHot: true,
    isNew: true,
    views: 2340000,
    releaseDate: '2025-07-20',
  },
  {
    id: 3,
    title: '爆笑一家人',
    originalTitle: 'Hilarious Family',
    category: 'xiju',
    year: 2025,
    rating: 8.3,
    duration: '112分钟',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20movie%20poster%20with%20a%20family%20of%20four%20making%20funny%20faces%2C%20bright%20and%20colorful%20background%2C%20warm%20lighting%2C%20playful%20atmosphere%2C%20movie%20poster%20style&width=600&height=900&seq=movie-poster-003&orientation=portrait',
    description: '一家四口为了争夺爷爷留下的"神秘遗产"，展开了一场啼笑皆非的较量。每个人都有自己的小算盘，却没想到遗产背后藏着更大的秘密。',
    tags: ['喜剧', '家庭', '温情', '搞笑'],
    director: '徐峥',
    actors: ['沈腾', '马丽', '艾伦', '常远'],
    region: '中国大陆',
    isHot: true,
    isNew: false,
    views: 980000,
    releaseDate: '2025-06-01',
  },
  {
    id: 4,
    title: '第七个嫌疑人',
    originalTitle: 'The Seventh Suspect',
    category: 'xuanyi',
    year: 2025,
    rating: 8.9,
    duration: '118分钟',
    poster: 'https://readdy.ai/api/search-image?query=Suspense%20thriller%20movie%20poster%20with%20a%20detective%20silhouette%20against%20a%20rainy%20city%20street%2C%20noir%20lighting%2C%20dark%20moody%20atmosphere%2C%20mysterious%20vibe%2C%20cinematic%20style&width=600&height=900&seq=movie-poster-004&orientation=portrait',
    description: '一个连环杀人案，五个嫌疑人，但真正的凶手却隐藏在第六个人之中。刑警队长必须在72小时内找出真相，否则下一个受害者就是他自己。',
    tags: ['悬疑', '犯罪', '推理', '反转'],
    director: '忻钰坤',
    actors: ['张译', '段奕宏', '邓超', '王千源'],
    region: '中国大陆',
    isHot: true,
    isNew: true,
    views: 1560000,
    releaseDate: '2025-08-01',
  },
  {
    id: 5,
    title: '暗夜惊魂',
    originalTitle: 'Night Terror',
    category: 'kongbu',
    year: 2025,
    rating: 7.6,
    duration: '98分钟',
    poster: 'https://readdy.ai/api/search-image?query=Horror%20movie%20poster%20with%20a%20haunted%20house%20at%20night%2C%20full%20moon%2C%20foggy%20atmosphere%2C%20dark%20and%20creepy%2C%20silhouetted%20trees%2C%20cinematic%20horror%20style&width=600&height=900&seq=movie-poster-005&orientation=portrait',
    description: '一群大学生在郊外别墅度假，却发现这栋房子隐藏着可怕的秘密。当午夜钟声响起，恐怖的真相揭开，他们一个接一个地失踪……',
    tags: ['恐怖', '惊悚', '校园', '灵异'],
    director: '温子仁',
    actors: ['彭于晏', '赵丽颖', '肖战'],
    region: '中国香港',
    isHot: false,
    isNew: true,
    views: 720000,
    releaseDate: '2025-07-30',
  },
  {
    id: 6,
    title: '春风十里不如你',
    originalTitle: 'Spring Breeze',
    category: 'aiqing',
    year: 2025,
    rating: 8.1,
    duration: '105分钟',
    poster: 'https://readdy.ai/api/search-image?query=Romantic%20movie%20poster%20with%20a%20couple%20walking%20under%20cherry%20blossom%20trees%2C%20soft%20pink%20and%20warm%20tones%2C%20dreamy%20atmosphere%2C%20spring%20setting%2C%20cinematic%20romance%20style&width=600&height=900&seq=movie-poster-006&orientation=portrait',
    description: '两个年轻人在最美的春天相遇，却因为命运的捉弄一次次错过。十年之后，当他们在樱花树下重逢，才发现彼此才是此生唯一。',
    tags: ['爱情', '青春', '文艺', '感人'],
    director: '陈可辛',
    actors: ['刘亦菲', '易烊千玺', '周冬雨'],
    region: '中国大陆',
    isHot: false,
    isNew: false,
    views: 890000,
    releaseDate: '2025-04-20',
  },
  {
    id: 7,
    title: '决战中途岛',
    originalTitle: 'Battle of Midway',
    category: 'zhanzheng',
    year: 2025,
    rating: 8.5,
    duration: '155分钟',
    poster: 'https://readdy.ai/api/search-image?query=War%20movie%20poster%20with%20naval%20battleships%20and%20fighter%20planes%20in%20epic%20combat%2C%20explosions%20over%20the%20ocean%2C%20dramatic%20sky%2C%20cinematic%20war%20film%20style&width=600&height=900&seq=movie-poster-007&orientation=portrait',
    description: '1942年，太平洋战场的关键转折点。美军以少敌多，在中途岛海域展开了一场改变二战格局的惊天海战。历史的车轮，在此刻转动。',
    tags: ['战争', '历史', '海战', '史诗'],
    director: '罗兰·艾默里奇',
    actors: ['李连杰', '甄子丹', '张涵予'],
    region: '中美合拍',
    isHot: true,
    isNew: false,
    views: 1870000,
    releaseDate: '2025-05-01',
  },
  {
    id: 8,
    title: '功夫熊猫5',
    originalTitle: 'Kung Fu Panda 5',
    category: 'donghua',
    year: 2025,
    rating: 8.4,
    duration: '95分钟',
    poster: 'https://readdy.ai/api/search-image?query=Animated%20movie%20poster%20with%20a%20panda%20in%20martial%20arts%20pose%2C%20vibrant%20Chinese%20style%20background%2C%20colorful%20and%20dynamic%2C%20family%20animation%20movie%20style&width=600&height=900&seq=movie-poster-008&orientation=portrait',
    description: '阿宝这次要面对来自远古的邪恶力量。他和盖世五侠一起，穿越时空回到古代中国，学习失传已久的绝世武功，保护和平谷的安宁。',
    tags: ['动画', '喜剧', '功夫', '家庭'],
    director: '詹妮弗·余',
    actors: ['黄渤', '成龙', '杨紫琼'],
    region: '中美合拍',
    isHot: false,
    isNew: true,
    views: 2100000,
    releaseDate: '2025-08-10',
  },
  {
    id: 9,
    title: '荒野求生',
    originalTitle: 'Into the Wild',
    category: 'jilu',
    year: 2025,
    rating: 9.2,
    duration: '92分钟',
    poster: 'https://readdy.ai/api/search-image?query=Documentary%20movie%20poster%20with%20a%20lone%20explorer%20on%20a%20vast%20mountain%20landscape%2C%20golden%20hour%20lighting%2C%20epic%20natural%20scenery%2C%20adventure%20documentary%20style&width=600&height=900&seq=movie-poster-009&orientation=portrait',
    description: '跟随探险家李明的脚步，深入亚马逊雨林、撒哈拉沙漠和南极冰川，记录人类在极端环境下的生存故事。每一帧都是对生命的礼赞。',
    tags: ['纪录片', '探险', '自然', '人性'],
    director: '李明',
    actors: ['李明'],
    region: '中国大陆',
    isHot: false,
    isNew: false,
    views: 450000,
    releaseDate: '2025-03-15',
  },
  {
    id: 10,
    title: '武林争霸',
    originalTitle: 'Martial Arts Supreme',
    category: 'dongzuo',
    year: 2025,
    rating: 7.9,
    duration: '135分钟',
    poster: 'https://readdy.ai/api/search-image?query=Martial%20arts%20movie%20poster%20with%20two%20warriors%20fighting%20on%20a%20rooftop%20at%20sunset%2C%20traditional%20Chinese%20costumes%2C%20dramatic%20lighting%2C%20epic%20cinematic%20style&width=600&height=900&seq=movie-poster-010&orientation=portrait',
    description: '明朝末年，武林各派为争夺一本绝世武功秘籍展开激烈争斗。一个无名少年在乱世中崛起，凭借自己的侠义之心，最终成为一代宗师。',
    tags: ['动作', '武侠', '古装', '江湖'],
    director: '徐克',
    actors: ['甄子丹', '吴京', '李连杰', '赵文卓'],
    region: '中国香港',
    isHot: false,
    isNew: false,
    views: 1100000,
    releaseDate: '2025-02-10',
  },
  {
    id: 11,
    title: '流浪地球3',
    originalTitle: 'The Wandering Earth 3',
    category: 'kehuan',
    year: 2025,
    rating: 9.0,
    duration: '160分钟',
    poster: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20sci-fi%20movie%20poster%20with%20Earth%20and%20massive%20engines%20in%20space%2C%20frozen%20planet%20surface%2C%20dramatic%20cosmic%20lighting%2C%20blockbuster%20style&width=600&height=900&seq=movie-poster-011&orientation=portrait',
    description: '地球在宇宙中继续流浪，前方遭遇了未知的黑洞区域。人类面临前所未有的挑战，必须在生存与希望之间做出艰难的抉择。',
    tags: ['科幻', '灾难', '史诗', '国产科幻'],
    director: '郭帆',
    actors: ['吴京', '吴孟达', '李雪健', '沙溢'],
    region: '中国大陆',
    isHot: true,
    isNew: true,
    views: 3500000,
    releaseDate: '2025-07-25',
  },
  {
    id: 12,
    title: '开心麻花之疯狂度假',
    originalTitle: 'Crazy Vacation',
    category: 'xiju',
    year: 2025,
    rating: 8.0,
    duration: '108分钟',
    poster: 'https://readdy.ai/api/search-image?query=Comedy%20movie%20poster%20with%20three%20friends%20at%20a%20tropical%20beach%20in%20funny%20situations%2C%20bright%20sunny%20colors%2C%20hilarious%20expressions%2C%20vacation%20theme&width=600&height=900&seq=movie-poster-012&orientation=portrait',
    description: '三个好兄弟去东南亚度假，却阴差阳错卷入了一场国际珠宝大劫案。笨贼遇上蠢警察，一场令人捧腹的闹剧就此展开。',
    tags: ['喜剧', '冒险', '动作喜剧', '搞笑'],
    director: '闫非',
    actors: ['沈腾', '黄渤', '王宝强'],
    region: '中国大陆',
    isHot: false,
    isNew: false,
    views: 760000,
    releaseDate: '2025-01-25',
  },
];